import { Link, type LinkProps } from 'react-router-dom';
import { Icon } from '../lib/icons';
import { cn } from '../lib/cn';

type ButtonLinkProps = LinkProps & {
  variant?: 'primary' | 'secondary' | 'dark' | 'ghost';
  icon?: boolean;
};

const variants = {
  primary:
    'bg-brand-teal text-brand-dark shadow-card hover:bg-brand-tealLight hover:-translate-y-0.5',
  secondary:
    'bg-white text-brand-navy ring-1 ring-brand-border hover:bg-brand-background hover:-translate-y-0.5',
  dark:
    'bg-brand-dark text-white shadow-card hover:bg-brand-navy hover:-translate-y-0.5',
  ghost:
    'bg-transparent text-brand-navy ring-1 ring-brand-border hover:bg-white hover:-translate-y-0.5'
};

export function ButtonLink({ className, variant = 'primary', icon = true, children, ...props }: ButtonLinkProps) {
  return (
    <Link
      className={cn(
        'inline-flex min-h-12 items-center justify-center gap-3 rounded-md px-6 py-3 text-sm font-bold transition duration-200 focus-visible:outline-brand-teal',
        variants[variant],
        className
      )}
      {...props}
    >
      <span>{children}</span>
      {icon ? <Icon name="arrowRight" className="h-4 w-4" /> : null}
    </Link>
  );
}
